import { PublicClientApplication } from '@azure/msal-browser'
import { EventType } from '@azure/msal-browser';
import { getSettings } from './settings'

const buildAppIdUri = (tenantId, servicePrincipal) =>
    "api://".concat(tenantId, "/", servicePrincipal, "/user_impersonation");

let fmMsalInstance;

const fmAuthConfig = async () => {
    if (fmMsalInstance == null) {
        const settings = await getSettings();
        const clientId = settings.fmClientId || settings.clientId;
        const tenant = settings.tenantId;
        const fmServicePrincipal = settings.finalMileServicePrincipal || settings.servicePrincipal;
        const appIdUri = buildAppIdUri(tenant, fmServicePrincipal);

        const msalConfig = {
            auth: {
                clientId: clientId,
                authority: "https://login.microsoftonline.com/".concat(tenant),
                redirectUri: window.location.origin,
            },
            system: {
                allowRedirectInIframe: true
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            }
        };

        const loginScopes = {
            scopes: ["User.Read", appIdUri]
        };

        fmMsalInstance = new PublicClientApplication(msalConfig);
        fmMsalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
                fmMsalInstance.setActiveAccount(event.payload.account);
            }
        }, error => {
            console.log("FM addEventCallback failed");
            console.log('error', error);
        });
        await fmMsalInstance.handleRedirectPromise()
            .then(async (tokenResponse) => {
                if (!tokenResponse) {
                    const accounts = fmMsalInstance.getAllAccounts();
                    if (accounts.length === 0) {
                        console.log("FM. handleRedirectPromise, loginRedirect");
                        await fmMsalInstance.loginRedirect(loginScopes);
                    }
                } else {
                    fmMsalInstance.setActiveAccount(tokenResponse.account);
                    return fmMsalInstance;
                }
            })
            .catch(err => {
                console.error("FM. Failed to handleRedirectPromise", err);
            });

        const accounts = fmMsalInstance.getAllAccounts();
        if (accounts.length === 0) {
            console.log("FM. No user signed in, loginRedirect");
            await fmMsalInstance.loginRedirect(loginScopes);
        }
    }

    return fmMsalInstance;
};

export const fmAuthToken = async () => {
    const msalInstance = await fmAuthConfig();
    const settings = await getSettings();
    const activeAccount = msalInstance.getActiveAccount();
    const fmServicePrincipal = settings.finalMileServicePrincipal || settings.servicePrincipal;
    const appIdUri = buildAppIdUri(settings.tenantId, fmServicePrincipal);

    if (!activeAccount) {
        const loginScopes = {
            scopes: ["User.Read", appIdUri]
        };
        await msalInstance.loginRedirect(loginScopes);
    }

    const request = {
        scopes: [appIdUri],
        account: activeAccount
    };

    return await msalInstance.acquireTokenSilent(request);
}
